import { useTranslation } from "react-i18next";

export function Footer() {
    const { t } = useTranslation();
    return (
        <footer>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '5px'}}>
                <p style={{textAlign: 'center', fontWeight: 800, fontSize: '25px'}}>{t('footer_brand')}</p>
                <p style={{textAlign: 'center'}}>{t('footer_tagline')}</p>
            </div>
        </footer>

    )
}